import {ModelBase} from "../../../models/model-base";
import {IModelBase} from "../../../models/i-model-base";
import {CashPointEntryDto} from "./cash-point-entry-dto";

export class DeviceNl extends ModelBase implements IModelBase {
  isLockedOut: boolean = false;
  serialNumber: string | undefined;
  location: string | undefined;

  // only for display (webapp)
  cashPointEntries: CashPointEntryDto[] = [];
}
